import React, { useState } from 'react';
import { OteGameOteTeam } from '~/src/models/OteGameOteTeam';
import { OteTeam } from '~/src/models/OteTeam';
import { colorFromInt } from '~/src/overtime-lib/src/www/lib';
import { imgOteLogoWhiteSvg } from '../../images';
import { OteGame } from '../../models/OteGame';
import { getThemeTeam, OteTheme } from '../../models/OteTheme';
import './TeamStats.scss';

const TeamLogo = ({ ote_team, ote_game }: { ote_team: OteTeam; ote_game: OteGame }) => {
	const [themeTeam, setThemeTeam] = useState<OteTheme>(getThemeTeam(ote_team?.id, ote_game.theme_name));
	const [logoPath, setLogoPath] = useState<string>(
		themeTeam
			? `https://images.overtime.tv/${themeTeam.logo_path}`
			: ote_team?.small_logo_path
				? `https://images.overtime.tv/${ote_team?.small_logo_path}?width=80&format=webp`
				: ote_team?.logo_path
					? `https://images.overtime.tv/${ote_team?.logo_path}?width=80&format=webp`
					: `${imgOteLogoWhiteSvg}`,
	);
	const [primaryColor, setPrimaryColor] = useState<number>(
		themeTeam ? themeTeam.primary_color : ote_team?.primary_color,
	);

	return (
		<a
			href={ote_team ? `/teams/${ote_team?.slug}` : undefined}
			className="TeamLogo"
			style={{
				backgroundColor: colorFromInt(primaryColor),
				backgroundImage: `url(${logoPath})`,
			}}
		>
			{!ote_team?.small_logo_path && !ote_team?.logo_path ? ote_team?.team_code?.[0] : null}
		</a>
	);
};

const TeamStats = ({
	game,
	awayGameTeam,
	homeGameTeam,
}: {
	game: OteGame;
	awayGameTeam: OteGameOteTeam;
	homeGameTeam: OteGameOteTeam;
}) => {
	if (!awayGameTeam || !homeGameTeam) {
		return null;
	}

	const [themeTeamHome, setThemeTeamHome] = useState<OteTheme>(
		getThemeTeam(homeGameTeam?.ote_team_id, game.theme_name),
	);
	const [themeTeamAway, setThemeTeamAway] = useState<OteTheme>(
		getThemeTeam(awayGameTeam?.ote_team_id, game.theme_name),
	);
	const [homeTeamPrimaryColor, setHomeTeamPrimaryColor] = useState<number>(
		themeTeamHome ? themeTeamHome.primary_color : homeGameTeam?.ote_team.primary_color,
	);
	const [awayTeamPrimaryColor, setAwayTeamPrimaryColor] = useState<number>(
		themeTeamAway ? themeTeamAway.primary_color : awayGameTeam?.ote_team.primary_color,
	);

	const statNames = [
		['points', 'pts'],
		['rebounds_total', 'reb'],
		['assists', 'ast'],
		['steals', 'stl'],
		['blocks', 'blk'],
		['turnovers', 'to'],
	];
	const stats = statNames.map((s) => {
		const maxValue = Math.max(awayGameTeam[s[0]] ?? 0, homeGameTeam[s[0]] ?? 0);
		return {
			name: s[0],
			key: s[1],
			awayValue: awayGameTeam[s[0]] ?? 0,
			homeValue: homeGameTeam[s[0]] ?? 0,
			awayRatio: maxValue > 0 ? (awayGameTeam[s[0]] / maxValue) * 100 : 0,
			homeRatio: maxValue > 0 ? (homeGameTeam[s[0]] / maxValue) * 100 : 0,
		};
	});

	return (
		<div className="GameTeamStats">
			<h2>Team Stats</h2>
			<div className="TeamLogosContainer">
				<TeamLogo ote_game={game} ote_team={awayGameTeam.ote_team} />
				<TeamLogo ote_game={game} ote_team={homeGameTeam.ote_team} />
			</div>
			<div className="StatsContainer">
				{stats.map((s) => (
					<div className="Stat" key={s.key}>
						<div className="AwayTeam">
							<div>{s.awayValue}</div>
							<div className="Chart" aria-label={`${awayGameTeam.ote_team.name} ${s.name}`}>
								<div
									className="Bar"
									style={{
										width: `${s.awayRatio}%`,
										backgroundColor: colorFromInt(awayTeamPrimaryColor),
									}}
								></div>
							</div>
						</div>
						<div className="Name">{s.key}</div>
						<div className="HomeTeam">
							<div>{s.homeValue}</div>
							<div className="Chart" aria-label={`${homeGameTeam.ote_team.name} ${s.name}`}>
								<div
									className="Bar"
									style={{
										width: `${s.homeRatio}%`,
										backgroundColor: colorFromInt(homeTeamPrimaryColor),
									}}
								></div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
export default TeamStats;
